const features = [
  {
    id: 1,
    icon: 'ri-speed-up-line',
    title: '极速播放不缓冲',
    desc: '采用先进的CDN加速和多线服务器，确保高清视频播放流畅不卡顿，无论是高峰期还是深夜都能畅快观影。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清画质全覆盖',
    desc: '支持从标清到超清多种画质选择，智能适配你的网络环境。热门内容均提供1080P高清版本，细节清晰可见。',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: '多站资源聚合',
    desc: '一站式聚合红桃视频、樱桃视频、茄子视频、糖心视频等热门站点内容，无需频繁切换平台即可浏览全网好片。',
  },
  {
    id: 4,
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '与各大视频源保持实时同步，新剧上线第一时间更新，热门综艺隔日可看，不错过任何精彩内容。',
  },
  {
    id: 5,
    icon: 'ri-shield-check-line',
    title: '纯净观影环境',
    desc: '清爽简洁的界面设计，无弹窗骚扰，无强制跳转。专注提供纯粹的影视观看体验，让你沉浸其中。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-shield-star-line"></i>
            <span>为什么选择我们</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            五大核心优势，为你打造最佳的在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.slice(0, 3).map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${feature.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {features.slice(3, 5).map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${feature.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}